// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Calendar from 'v-calendar/lib/components/calendar.umd';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import Notifications from 'vue-notification';
import BootstrapVue from 'bootstrap-vue';
import VueStripeCheckout from 'vue-stripe-checkout';
import VeeValidate from 'vee-validate';
import feather from 'vue-icon';
import VueCookie from 'vue-cookie';
import VueMoment from 'vue-moment';
import moment from 'moment';
import Vue from 'vue';
import App from './App';
import router from './router';
import VCalendar from 'v-calendar';
import vueNumeralFilterInstaller from 'vue-numeral-filter';


const publishableKey = process.env.STRIPE_PUBLISHABLE;
const options = {
  key: publishableKey,
  image: './static/logo.png',
  locale: 'auto',
  currency: 'GBP',
};

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(VueStripeCheckout, options);
Vue.use(VeeValidate, {fieldsBagName: 'formFields'});
Vue.use(vueNumeralFilterInstaller, { locale: 'en-gb' });
Vue.use(feather, 'v-icon');
Vue.use(VueCookie);
Vue.use(VCalendar, {});
Vue.use(VueMoment, {
  moment,
});
/* eslint-disable no-new */
Vue.prototype.$eventHub = new Vue();

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js